import { PageQuery } from 'src/models';

export const DEFAULT_QUERY: PageQuery = {
  filter: {},
  hidden: [],
  search: {},
  sort: {},
};
